import React from "react";
import './EMR.css'
import '../components/ProductsHeroBanner';
import ProductHeroBanner from "../components/ProductsHeroBanner";
import Navbar from '../components/Navbar'
//import Solutions from "../components/Solutions";
//import emrSolutionsData from "../components/emrSolutionsData";
import Footer from "../components/Footer";
import ContentBlocks from "../components/ContentBlocks";
import CallToAction from "../components/CallToAction";
import { Helmet } from "react-helmet";

const EMR = () => {

    const pageData = {
        heading: "EMR Features",
        blocks: [
            {
                blockHeading: "Electronic Medical Records",
                text: "Support your practice’s entire clinical workflow and control how you deliver care with Doclivo’s electronic medical record (EMR)."
            },
            {
                blockHeading: "Electronic Prescriptions",
                text: "Ease staff and patient frustration with faster, easier ePrescriptions, offering patients a transparent view of their medication orders."
            },
            {
                blockHeading: "Electronic Labs",
                text: "Track patient progress over time with a comprehensive view of data, including patient vitals and lab results."
            },
            {
                blockHeading: "Online Appointment Scheduling",
                text: "Empower patients to book appointments directly with your practice, freeing up staff for critical tasks, and streamline appointment confirmations to reduce no-shows."
            },
            {
                blockHeading: "Appointment Reminders",
                text: "Decrease late appointments, no-shows, and cancellations, while allowing office staff more time to focus on essential tasks."
            }
        ]
    };


    return (
        <>
            <Helmet>
                <title> EMR - Doclivo</title>
                <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
                <meta name="keywords" content="about us, company, automation" />
            </Helmet>
            <Navbar></Navbar>
            <section className="emr-section">
                <div className="emr-container">
                    <h5 className="emr-subheading">Electronic Medical Records </h5>
                    <h1 className="emr-main-heading">Maximize time with patients, minimize documentation time, and optimize reimbursements</h1>
                </div>

                <ProductHeroBanner></ProductHeroBanner>

            

                <ContentBlocks
                    heading={pageData.heading}
                    subheading={pageData.subheading}
                    blocks={pageData.blocks}
                />
                <CallToAction></CallToAction>
            </section>
            <Footer></Footer>
        </>
    );
};

export default EMR;